import React from "react";
import { motion } from "framer-motion";
import ResumeCard from "./ResumeCard";

const Education = () => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1, transition: { duration: 0.5 } }}
      className="w-full flex flex-col lgl:flex-row gap-10 lgl:gap-20"
    >
      {/* part one */}
      <div>
        <div className="py-6 lgl:py-12 font-titleFont flex flex-col gap-4">
          <p className="text-sm text-designColor tracking-[4px]">School & College</p>
          <h2 className="text-3xl md:text-4xl font-bold">Education </h2>
        </div>
        <div className="mt-6 lgl:mt-14 w-full  border-l-[6px] border-l-black border-opacity-30 flex flex-col gap-10">
          <ResumeCard
            title="B.E. in Computer Science and Engineering"
            subTitle="SRM TRP Engineering College (2020 - 2024)"
            result="7.8/10 CGPA"
            des="Gained core computer science subjects and learned software development and modern technologies."
          />
          <ResumeCard
            title="HSE - Mathematics & ComputerScience"
            subTitle="Rahmania Matric. Higher Secondary School (2018 - 2020)"
            result="70%"
            des="Focused on Computer Science, gaining a strong foundation in programming, algorithms, and computational thinking."
          />
        </div>
      </div>

      {/* part Two */}
      <div>
        <div className="py-6 lgl:py-12 font-titleFont flex flex-col gap-4">
          <p className="text-sm text-designColor tracking-[4px]">Course's</p>
          <h2 className="text-3xl md:text-4xl font-bold">Certifications</h2>
        </div>
        <div className="mt-6 lgl:mt-14 w-full  border-l-[6px] border-l-black border-opacity-30 flex flex-col gap-10">   
          <ResumeCard
            title="Digital Marketing Trainee"
            subTitle="Trioangle Technologies - Present"
            result="Madurai"
            des="Performed SEO activities including on-page, off-page, technical SEO, keyword research, and content optimization."
          />
          <ResumeCard
            title="Digital Marketing"
            subTitle="Zenshin Technology"
            result="Madurai"
            des="Hands-on digital marketing internship with experience in SEO, SEM, social media marketing, analytics, and keyword research."
          />
          <ResumeCard
            title="Full Stack Development"
            subTitle="Greens Technology"
            result="Chennai"
            des="Completed a web development course covering both front-end and back-end, gaining hands-on experience in building web applications."
          />
        </div>
      </div>
    </motion.div>
  );
};

export default Education;
